import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
	changeNextPath,
	clickLogout
} from '../../actions';


const styles = theme => ({
	pankuzu : {
		position:'absolute',
		display:'inline-block',
		left:20,
		top:11,
	},
	menuText : {
		color:'#40bad0',
		lineHeight:'25px',
		verticalAlign:'top',
		display:'inline-block',
		cursor:'pointer'
	},
	iconStyle:{
		color:'rgba(0,0,0,0.2)'
	},
	headerTop:{
		display:'flex',
		justifyContent:'space-between',
		alignItems:'center',
		paddingRight:60,
		height:'100%'
	},
	contactInformation:{
		textAlign:'center',
		borderRight:'solid rgba(0,0,0,0.1) 1px',
		paddingRight: 20
	},
	contactInformationTitle:{
		color:'rgba(0,0,0,0.85)',
		fontSize:'90%',
		borderColor:'rgba(0,0,0,0.15)',
		backgroundColor:'rgba(0,0,0,0.02)',
		borderWidth:1,
		borderStyle:'solid',
		borderRadius:30,
		marginBottom:3
	},
	contactInformationTitleMain:{
		fontFamily:'"Noto Sans JP","ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro",Osaka,"メイリオ","Meiryo","ＭＳ Ｐゴシック","MS PGothic"',
		fontWeight:700
	},
	contactInformationTitleSpan:{
		marginLeft:5,
		fontSize:'90%'
	},
	contactInfoInner:{
		display:'flex',
		alignItems:'center'
	},
	contactInfoInnerP:{
		'& > span':{
			marginRight: 5,
			color:'rgba(0,0,0,0.67)',
			fontSize:20
		},
		fontSize:'110%',
		fontFamily: '"Roboto",Sans-Serif',
		fontStyle: 'normal',
		fontWeight: 400,
		display:'flex',
		alignItems:'center',
		lineHeight: '18px'
	},
	contactInfoInnerTel:{
		color: 'rgba(0, 0, 0, 0.8)',
		marginRight:10,
	},
	contactInfoInnerMail:{
		'& > a':{
			fontFamily: '"Roboto",Sans-Serif',
			fontStyle: 'normal',
			fontWeight: 300,
		}
	}
});

class header extends React.Component {

	handleClickLogout = () => {
		const {dispatch,history,auth} = this.props;
		dispatch(clickLogout({SessionID:auth.SessionID}));
		history.push('/');
	};

	handleClickMenu = () => {
		const doFunc = () =>{
			this.props.dispatch(changeNextPath({nextPath:'menu'}));
			this.props.history.push('/');
		};

		if(this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		}
		else{
			doFunc();
		}
	};

	render () {
		const {auth, classes, navigations} = this.props;

		return (
			<header>
				<div className="head_wrap">
					<div id="head_top" className={classes.headerTop}>
						<h1>
							<img src="/images/common/logo.png" alt="telesa-delivery" />
						</h1>
						<div className={classes.contactInformation}>
							<p className={classes.contactInformationTitle}>
								<span className={classes.contactInformationTitleMain}>お問い合わせはこちら</span>
								<span className={classes.contactInformationTitleSpan}>(平日10:00 - 18:00)</span>
							</p>
							<div className={classes.contactInfoInner}>
								<p className={classNames(classes.contactInfoInnerP, classes.contactInfoInnerTel)}>
							<span className="material-icons">
								local_phone
							</span>
									050-1742-3567
								</p>
								<p className={classNames(classes.contactInfoInnerP, classes.contactInfoInnerMail)}>
							<span className="material-icons">
								email
							</span>
									<a href={"mailto:customer@tsunagute.co.jp"}>customer@tsunagute.co.jp</a>
								</p>
							</div>
						</div>

					</div>
				</div>
				{auth.isLoggedIn &&
				<div className="logins">
					{this.props.navigation.currentPath !== '/' &&
					<p className={classes.pankuzu}>
						<span onClick={this.handleClickMenu} className={classes.menuText}>
							<i className="fa fa-bars" aria-hidden="true"/>メインメニュー
						</span>
						{navigations.map((menu,index)=>{
							return([
								<i className={classNames(classes.iconStyle,"material-icons")} key={"icon" + index}>
									navigate_next
								</i>,
								<span onClick={menu.clickFunc} className={classes.menuText} key={"menu" + index}>
									{menu.name}
								</span>
							])
						})}
					</p>
					}
					<p className="login_name">
						<i className="fa fa-user-circle" aria-hidden="true"/>
						<span>{auth.user.UserName} でログイン中</span>
					</p>
					<p className="logout" onClick={this.handleClickLogout}><i className="fa fa-sign-out" aria-hidden="true"/>ログアウト</p>
				</div>
				}
			</header>
		);
	}
}

header.propTypes = {
	history: PropTypes.object,
	redirectFunc : PropTypes.func,
	navigations : PropTypes.array,
};
header.defaultProps = {
	navigations : [],
};
function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(header);



// WEBPACK FOOTER //
// ./src/common/containers/header.js